import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { EXCHNAGE_URL } from '../../../../../Url/Url';
import axios from 'axios';
import { toast } from 'react-toastify';
import { GreyBackgroundButton, GreyBorderButton, RedBackgroundButton } from '../../../../Global/GlobalButton';
import FormCanvas from '../../../../Admin-Creating-New-Event/MyEvents/EntryForm/EntryFormChild/FormCanvas';
import Side from '../../../../Admin-Creating-New-Event/MyEvents/EntryForm/EntryFormChild/Side';
import FormPreview from '../../../../Admin-Creating-New-Event/MyEvents/EntryForm/EntryFormChild/FormPreview';
import { removeFieldFromEntryPayload, resetEntryState, SET_ENTRY_FORM_ID, setEntryFormId } from '../../../../Redux/Users/action';
import { setEntryFieldPayload } from '../../../../Redux/Users/EntryFieldAction';
import { useLoading } from '../../../../LoadingContext';
import { useNavigate } from 'react-router-dom';




export const UpdateNewEntryForm = ({ entFormSchema, setSelectedButton, updatedField, setShowFormTwo, onSaveSuccess }) => {
  const [fields, setFields] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showSavedForm, setShowSavedForm] = useState(false);
  const [savedFormId, setSavedFormId] = useState(null);
  const [addedFields, setAddedFields] = useState([])
  const [formSchema, setFormSchema] = useState([]);
  const [copiedFields, setCopiedFields] = useState([]);
  const [formData, setFormData] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [draggedCategory, setDraggedCategory] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [isDragging, setIsDragging] = useState(false);

  const dispatch = useDispatch();
  const eventIdGet = useSelector((state) => state?.users?.id);
  const eventId = String(eventIdGet);
  const entryFieldPayload = useSelector((state) => state.entry.fieldPayload);
  console.log(entryFieldPayload, "11adfadfsdf1")
  const entryFormId = useSelector((state) => state?.users?.entryFormId);
  const { setLoading } = useLoading(); 
  const navigate = useNavigate();


  const defaultFields = useMemo(() => [
    {
      type: "dropdown",
      label: "Category",
      dataName: `category-${Date.now()}`,
      placeholder: "Enter category...",
      required: true,
      charLimitRequired: false,
      wordLimit: "",
      fieldSize: "100%",
      defaultValue: "",
      isDefault: true,
      visible: true,
    },
    {
      type: "text",
      label: "Title of the Entry",
      dataName: `title-${Date.now()}`,
      placeholder: "Enter title...",
      required: true,
      charLimitRequired: false,
      wordLimit: "",
      fieldSize: "100%",
      defaultValue: "",
      isDefault: true,
      visible: true,
    },
    // {
    //   type: "email",
    //   label: "Email",
    //   dataName: `emailDef-${Date.now()}`,
    //   placeholder: "Enter Email...",
    //   required: true,
    //   charLimitRequired: false,
    //   wordLimit: "",
    //   fieldSize: "100%",
    //   defaultValue: "",
    //   isDefault: true,
    //   visible: true,
    // },
    // {
    //   type: "text",
    //   label: "Name",
    //   dataName: `name-${Date.now()}`,
    //   placeholder: "Enter Name...",
    //   required: true,
    //   charLimitRequired: false,
    //   wordLimit: "",
    //   fieldSize: "100%",
    //   defaultValue: "",
    //   isDefault: true,
    //   visible: true,
    // },
    // {
    //   type: "tel",
    //   label: "Phone Number",
    //   dataName: `telDef-${Date.now()}`,
    //   placeholder: "Enter Phone Number...",
    //   required: true,
    //   charLimitRequired: false,
    //   wordLimit: "",
    //   fieldSize: "100%",
    //   defaultValue: "",
    //   isDefault: true,
    //   visible: true,
    // },
    // {
    //   type: "text",
    //   label: "Designation",
    //   dataName: `designation-${Date.now()}`,
    //   placeholder: "Enter Designation...",
    //   required: true,
    //   charLimitRequired: false,
    //   wordLimit: "",
    //   fieldSize: "100%",
    //   defaultValue: "",
    //   isDefault: true,
    //   visible: true,
    // }
  ], []);
  console.log(entFormSchema, "hellosasasasasas")

  const defaultPrefixes = ["category", "title", "emailDef", "name", "telDef", "designation"];

  const addField = (type) => {
    const newField = {
      label: { type: "label", label: "Label Text", required: false, visible: true, dataName: `label-${Date.now()}`, adminLabel: "Label Admin Label", description: "<p>This is an HTML description for the label.</p>", size: "h1" },
      text: { type: "text", label: "Single Line Text", dataName: `text-${Date.now()}`, placeholder: "Enter text...", required: false, visible: true, charLimitRequired: false, wordLimit: "", fieldSize: "100%" },
      textarea: { type: "textarea", label: "Paragraph Text", dataName: `textarea-${Date.now()}`, charLimitRequired: false, required: false, visible: true, wordLimitRequired: false, charLimit: "", wordLimit: "", fieldSize: "100%" },
      radio: { type: "radio", label: "Radio Button", required: false, visible: true, dataName: `radio-${Date.now()}`, options: ["Option 1", "Option 2"] },
      checkbox: { type: "checkbox", label: "Checkbox", required: false, visible: true, dataName: `checkbox-${Date.now()}`, options: ["Option 1", "Option 2"] },
      dropdown: { type: "dropdown", label: "Dropdown", required: false, visible: true, dataName: `dropdown-${Date.now()}`, options: ["Option 1", "Option 2", "Option 3"] },
      email: { type: "email", label: "Email", required: false, visible: true, dataName: `email-${Date.now()}`, placeholder: "Enter email..." },
      tel: { type: "tel", label: "Phone Number", required: false, visible: true, dataName: `tel-${Date.now()}`, placeholder: "Enter phone number..." },
      date: { type: "date", label: "Date Picker", required: false, visible: true, dataName: `date-${Date.now()}` },
      country: { type: "country", required: false, visible: true, label: "Country List", dataName: `country-${Date.now()}`, options: ["USA", "India", "Canada"] },
      file: { type: "file", label: "File Upload", required: false, visible: true, dataName: `file-${Date.now()}` },
    }; 



    if (newField[type]) {
      console.log("Before setting, addedFields is:", addedFields);
      setAddedFields((prevFields) => {
        console.log("Inside setAddedFields, prevFields:", prevFields);
        if (Array.isArray(prevFields)) {
          const updatedFields = [...prevFields, newField[type]];
          console.log("Updated addedFields:", updatedFields);
          return updatedFields;
        } else {
          console.error("addedFields is not an array", prevFields);
          return [newField[type]];
        }
      });
    } else {
      console.error("Invalid field type:", type);
    }
  };

  useEffect(() => {
    dispatch(resetEntryState());
    
    return () => {
      dispatch(resetEntryState());
    };
  }, [dispatch]);

  useEffect(() => {
    if (entFormSchema && Array.isArray(entFormSchema)) {
      const defaultPrefixes = ["category", "title", "emailDef", "name", "telDef", "designation"];
      
      console.log("Processing entFormSchema:", entFormSchema);
      
      // Create a copy of defaultFields to work with
      const updatedDefaultFields = [...defaultFields];
      const newAddedFields = [];
      
      // Process each field from the schema
      entFormSchema.forEach(field => {
        // Get dataName from either dataName or renderDataName property
        const dataName = field.dataName || field.renderDataName;
        
        if (!field || !dataName) {
          console.log("Skipping invalid field:", field);
          return;
        }
        
        // Normalize the field to ensure all array properties are arrays
        const normalizedField = {
          ...field,
          dataName: dataName,
          options: Array.isArray(field.options) ? field.options : [],
          requiredFieldValue: Array.isArray(field.requiredFieldValue) ? field.requiredFieldValue : [],
          requiredCondition: Array.isArray(field.requiredCondition) ? field.requiredCondition : [],
          requiredConditionValue: Array.isArray(field.requiredConditionValue) ? field.requiredConditionValue : [],
          requiredCriteriaPattern: field.requiredCriteriaPattern || "",
          visibleFieldValue: Array.isArray(field.visibleFieldValue) ? field.visibleFieldValue : [],
          visibleCondition: Array.isArray(field.visibleCondition) ? field.visibleCondition : [],
          visibleConditionValue: Array.isArray(field.visibleConditionValue) ? field.visibleConditionValue : [],
          visibleCriteriaPattern: field.visibleCriteriaPattern || "",
          addedSubfields: Array.isArray(field.addedSubfields) ? field.addedSubfields : [],
          uploadFileType: Array.isArray(field.uploadFileType) ? field.uploadFileType : [],
        };
        
        // Check if this is a default field by prefix
        const prefix = dataName.split('-')[0];
        const isDefaultField = defaultPrefixes.includes(prefix);
        
        if (isDefaultField) {
          // Find matching default field and update it
          const matchIndex = updatedDefaultFields.findIndex(df => 
            df.dataName.split('-')[0] === prefix
          );
          
          if (matchIndex !== -1) {
            // Update default field with saved properties
            updatedDefaultFields[matchIndex] = {
              ...updatedDefaultFields[matchIndex],
              ...normalizedField,
              isDefault: true
            };
          }
        } else {
          // This is an added field
          newAddedFields.push(normalizedField);
        }
        
        // Dispatch to Redux regardless of field type
        dispatch(setEntryFieldPayload(normalizedField));
      });
      
      console.log("Updated default fields:", updatedDefaultFields);
      console.log("New added fields:", newAddedFields);
      
      // Update state with processed fields
      setFields(updatedDefaultFields);
      setAddedFields(newAddedFields);
      setCopiedFields([]);
    } else {
      // If no schema or invalid schema, use default fields
      console.log("No valid schema, using default fields");
      setFields([...defaultFields]);
      setAddedFields([]);
      setCopiedFields([]);
    }
  }, [entFormSchema, defaultFields, dispatch]);


  console.log(addedFields, "addedFields")
  const copyField = (index) => {
    const fieldToCopy = addedFields[index];
    let copiedField;
    if (entryFieldPayload?.length > 0) {
      const matchingPayload = entryFieldPayload.find(item => item.dataName === fieldToCopy.dataName);

      if (matchingPayload) {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
          type: matchingPayload.type,
          addedSubfields: matchingPayload.addedSubfields || [],
          hoverHint: matchingPayload.hoverHint || "",
          options: [...(matchingPayload.options || [])],
          required: matchingPayload.required ?? false,
          includeOther: matchingPayload.includeOther ?? false,
          isRequiredIf: matchingPayload.isRequiredIf ?? false,
          requiredFieldValue: [...(matchingPayload.requiredFieldValue || [])],
          requiredCondition: [...(matchingPayload.requiredCondition || [])],
          requiredConditionValue: [...(matchingPayload.requiredConditionValue || [])],
          requiredCriteriaPattern: matchingPayload.requiredCriteriaPattern || "",
          visible: matchingPayload.visible ?? true,
          isVisibleIf: matchingPayload.isVisibleIf ?? false,
          visibleFieldValue: [...(matchingPayload.visibleFieldValue || [])],
          visibleCondition: [...(matchingPayload.visibleCondition || [])],
          visibleConditionValue: [...(matchingPayload.visibleConditionValue || [])],
          visibleCriteriaPattern: matchingPayload.visibleCriteriaPattern || "",
          isVisibleCheckedInJudging: matchingPayload.isVisibleCheckedInJudging ?? false,
          visibleInJudgingFieldValue: matchingPayload.visibleInJudgingFieldValue || "",
          visibleInJudgingCondition: matchingPayload.visibleInJudgingCondition || "Equals",
          visibleInJudgingInConditionValue: matchingPayload.visibleInJudgingInConditionValue || "",
          renderlabel: matchingPayload.renderlabel || "",
          renderDataName: matchingPayload.renderDataName || "",
          selectedLabelPosition: matchingPayload.selectedLabelPosition || "top",
          selectedFieldSize: matchingPayload.selectedFieldSize || "100%",
        };
        console.log("Copied Field with conditions from fieldPayload:", copiedField);
        const copiedFieldPayload = {
          ...matchingPayload,
          dataName: copiedField.dataName,
          label: copiedField.label,
          requiredCriteriaPattern: "",
          visibleCriteriaPattern: "",
        };
        console.log("Dispatching Copied Field Payload:", copiedFieldPayload);
        dispatch(setEntryFieldPayload(copiedFieldPayload));
      } else {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
          requiredCriteriaPattern: "",
          visibleCriteriaPattern: "",
        };
        console.log("Copied Field without matching conditions:", copiedField);
      }
    }
    else {
      copiedField = {
        ...fieldToCopy,
        dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
        label: `copy ${fieldToCopy.label}`,
        value: "",
        requiredCriteriaPattern: "",
        visibleCriteriaPattern: "",
      };
      console.log("Copied Field (fieldPayload is empty):", copiedField);
    }

    setCopiedFields((prevCopiedFields) => [...prevCopiedFields, copiedField]);

  };

  const copyNormalField = (index) => {
    const fieldToCopy = defaultFields[index];
    console.log(fieldToCopy, "fieldToCopy");
    let copiedField;
    if (entryFieldPayload?.length > 0) {
      const matchingPayload = entryFieldPayload.find(item => item.dataName === fieldToCopy.dataName);
      console.log(matchingPayload, "fieldToCopy")
      if (matchingPayload) {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
          type: matchingPayload.type,
          addedSubfields: matchingPayload.addedSubfields || [],
          hoverHint: matchingPayload.hoverHint || "",
          options: [...(matchingPayload.options || [])],
          required: matchingPayload.required ?? false,
          includeOther: matchingPayload.includeOther ?? false,
          isRequiredIf: matchingPayload.isRequiredIf ?? false,
          requiredFieldValue: [...(matchingPayload.requiredFieldValue || [])],
          requiredCondition: [...(matchingPayload.requiredCondition || [])],
          requiredConditionValue: [...(matchingPayload.requiredConditionValue || [])],
          requiredCriteriaPattern: matchingPayload.requiredCriteriaPattern || "",
          visible: matchingPayload.visible ?? true,
          isVisibleIf: matchingPayload.isVisibleIf ?? false,
          visibleFieldValue: [...(matchingPayload.visibleFieldValue || [])],
          visibleCondition: [...(matchingPayload.visibleCondition || [])],
          visibleConditionValue: [...(matchingPayload.visibleConditionValue || [])],
          visibleCriteriaPattern: matchingPayload.visibleCriteriaPattern || "",
          isVisibleCheckedInJudging: matchingPayload.isVisibleCheckedInJudging ?? false,
          visibleInJudgingFieldValue: matchingPayload.visibleInJudgingFieldValue || "",
          visibleInJudgingCondition: matchingPayload.visibleInJudgingCondition || "Equals",
          visibleInJudgingInConditionValue: matchingPayload.visibleInJudgingInConditionValue || "",
          renderlabel: matchingPayload.renderlabel || "",
          renderDataName: matchingPayload.renderDataName || "",
          selectedLabelPosition: matchingPayload.selectedLabelPosition || "top",
          selectedFieldSize: matchingPayload.selectedFieldSize || "100%",
        };
        console.log("Copied Field with conditions from fieldPayload:", copiedField);
        const copiedFieldPayload = {
          ...matchingPayload,
          dataName: copiedField.dataName,
          label: copiedField.label,
          requiredCriteriaPattern: "",
          visibleCriteriaPattern: "",
        };
        console.log("Dispatching Copied Field Payload:", copiedFieldPayload);
        dispatch(setEntryFieldPayload(copiedFieldPayload));
      } else {
        copiedField = {
          ...fieldToCopy,
          dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
          label: `copy ${fieldToCopy.label}`,
          value: "",
          requiredCriteriaPattern: "",
          visibleCriteriaPattern: "",
        };
        console.log("Copied Field without matching conditions:", copiedField);
      }
    }
    else {
      copiedField = {
        ...fieldToCopy,
        dataName: `${fieldToCopy.dataName}_copy_${Date.now()}`,
        label: `copy ${fieldToCopy.label}`,
        value: "",
        requiredCriteriaPattern: "",
        visibleCriteriaPattern: "",
      };
      console.log("Copied Field (fieldPayload is empty):", copiedField);
    }

    setCopiedFields((prevCopiedFields) => [...prevCopiedFields, copiedField]);

  };

  useEffect(() => {
    console.log("copiedFields updated:", copiedFields);
  }, [copiedFields]);




  const removeField = (index) => {
    const fieldToRemove = addedFields[index];
    setAddedFields(prev => prev.filter((_, i) => i !== index));
    
    dispatch(removeFieldFromEntryPayload(fieldToRemove.dataName));
    dispatch({ type: 'REMOVE_FIELD_FROM_PAYLOAD', payload: fieldToRemove.dataName });
  };

  const removeFieldFromCopied = (index) => {
    const fieldToRemove = copiedFields[index];
    setCopiedFields(copiedFields.filter((_, i) => i !== index));
    dispatch(removeFieldFromEntryPayload(fieldToRemove.dataName));
  };

  const updateField = (updatedFields) => {
    const updatedFormFields = fields.map((field) => {
      const updatedField = updatedFields.find((updated) => updated.dataName === field.dataName);
      console.log(updatedFields, "asdasdasd")
      if (updatedField) {
        return { ...field, ...updatedField };
      }
      return field;
    });

    setFields(updatedFormFields);
  };

  const updateAddedField = (index, updatedField) => {
    setAddedFields((prevFields) => {
      const newFields = [...prevFields];
      newFields[index] = { ...newFields[index], ...updatedField };
      return newFields;
    });
  };

  const updateCopiedField = (updatedFieldData) => {
    const updatedCopiedFields = copiedFields.map((field) => {
      if (field.dataName === updatedFieldData.dataName) {
        return { ...field, ...updatedFieldData };
      }
      return field;
    });
    setCopiedFields(updatedCopiedFields);
  };


  useEffect(() => {
      const initialData = formSchema.reduce((acc, field) => {
        acc[field.dataName] = {
          type:field.type,
          value: field.defaultValue || "",
          isConditionMet: true,
          isRequired: field.required || false,
          label: field.label,
          isVisible: field.visible || true,
          dataName: field.dataName || "",
          labelPosition: field.labelPosition || "",
          options:field.options || "",
          visible:field.visible,
        };
        return acc;
      }, {});

    if (JSON.stringify(formData) !== JSON.stringify(initialData)) {
      setFormData(initialData);
    }
  }, [formSchema]);



  useEffect(() => {
    const mergeFormDataWithPayload = () => {
      const updatedMergeData = { ...formData };
      entryFieldPayload.forEach(field => {
        const { dataName, ...rest } = field;
        if (updatedMergeData[dataName]) {
          updatedMergeData[dataName] = {
            ...updatedMergeData[dataName],
            ...rest,
          };
        } else {
          updatedMergeData[dataName] = {
            value: '',
            isConditionMet: true,
            isRequired: false,
            isVisible: true,
            ...rest,
          };
        }
      });

      return updatedMergeData;
    };

    const updatedMergeData = mergeFormDataWithPayload();
    if (JSON.stringify(formData) !== JSON.stringify(updatedMergeData)) {
      setFormData(updatedMergeData);
    }
  }, [entryFieldPayload, formData]);



  useEffect(() => {
    setFields([...defaultFields]);
  }, []);

  useEffect(() => {
    setFields([...defaultFields])
    setAddedFields();
  }, []);


  useEffect(() => {
    if (Array.isArray(fields) && Array.isArray(addedFields) && Array.isArray(copiedFields)) {
      const newFormSchema = [...fields, ...addedFields, ...copiedFields];
      console.log("Merged formSchema:", newFormSchema);
     console.log(
  "CONDITIONAL FIELDS",
  newFormSchema.filter(
    field =>
      field.isVisibleIf ||
      field.isRequiredIf ||
      field.visibleFieldValue?.length > 0 ||
      field.requiredFieldValue?.length > 0
  )
);
      setFormSchema(newFormSchema);
    }
    else if (formSchema.length === 0) {
      setFormSchema([...fields])
    }
  }, [fields, addedFields, copiedFields]);



  const saveForm = () => {
    if (!eventId) {
      console.error("Event ID is missing.");
      toast.error("Entry Form Failed, EventId Missing")
      return;
    }
    setLoading(true); // ✅ Start loading

    const convertFormDataToArray = (formData) => {
      return Object.entries(formData).map(([key, value]) => {
        return {
          ...value, // Spread the properties of the value object
          dataName: key // Add the key as dataName
        };
      });
    };
    const formSchemaArray = convertFormDataToArray(formData);

    const formPayload = { form_schema: formSchemaArray, eventId, entryFormId: entryFormId };

    axios.put(`${EXCHNAGE_URL}/entryForm`, formPayload, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        toast.success("Entry Form Updated Successfully.")
        dispatch(resetEntryState());
       
        setAddedFields([])
        setFormData([])
        setFormSchema([])
        setCopiedFields([])
        if (onSaveSuccess) {
          onSaveSuccess();
        }
        setShowFormTwo(false);
      })
      .catch((error) => {
        console.error("Error Updating form:", error);
        toast.error("Error Updating form. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const saveForm2 = () => {
    if (!eventId) {
      console.error("Event ID is missing.");
      toast.error("Entry Form Failed, EventId Missing")
      return;
    }
    setLoading(true);

    const convertFormDataToArray = (formData) => {
      return Object.entries(formData).map(([key, value]) => {
        return {
          ...value, 
          dataName: key 
        };
      });
    };
    const formSchemaArray = convertFormDataToArray(formData);

    const formPayload = { form_schema: formSchemaArray, eventId, entryFormId: entryFormId };

    axios.put(`${EXCHNAGE_URL}/entryForm`, formPayload, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        toast.success("Entry Form Updated Successfully.")
        dispatch(resetEntryState());
       
        setAddedFields([])
        setFormData([])
        setFormSchema([])
        setCopiedFields([])
        if (onSaveSuccess) {
          onSaveSuccess();
          setShowFormTwo(true);
        }
      })
      .catch((error) => {
        console.error("Error Updating form:", error);
        toast.error("Error Updating form. Please try again.");
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleDragStart = (e, index, category) => {
  setDraggedIndex(index);
  setDraggedCategory(category);
  setIsDragging(true);

  // 🔥 Ghost preview
  const dragPreview = e.currentTarget.cloneNode(true);
  dragPreview.style.position = "absolute";
  dragPreview.style.top = "-9999px";
  dragPreview.style.left = "-9999px";
  dragPreview.style.width = "250px";
  dragPreview.style.opacity = "0.8";
  dragPreview.style.transform = "scale(0.95)";
  dragPreview.style.boxShadow = "0 8px 20px rgba(0,0,0,0.2)";
  dragPreview.style.background = "#fff";
  dragPreview.style.padding = "10px";
  dragPreview.style.borderRadius = "8px";

  document.body.appendChild(dragPreview);
  e.dataTransfer.setDragImage(dragPreview, 120, 20);

  setTimeout(() => document.body.removeChild(dragPreview), 0);

  e.currentTarget.style.opacity = "0.4";
};

const handleDragEnd = (e) => {
  setIsDragging(false);
  setDragOverIndex(null);
  e.currentTarget.style.opacity = "1";
};

const handleDragOver = (e, index) => {
  e.preventDefault();
  setDragOverIndex(index);
};

const handleDragLeave = () => {
  setDragOverIndex(null);
};

  const handleDrop = (e, dropIndex, targetCategory) => {
  e.preventDefault();

  setDragOverIndex(null);
  setIsDragging(false);

  if (draggedCategory === targetCategory && draggedIndex === dropIndex) return;

  let targetCategoryState;
  let setState;

  if (draggedCategory === "fields") {
    targetCategoryState = [...fields];
    setState = setFields;
  } else if (draggedCategory === "addedFields") {
    targetCategoryState = [...addedFields];
    setState = setAddedFields;
  } else if (draggedCategory === "copiedFields") {
    targetCategoryState = [...copiedFields];
    setState = setCopiedFields;
  }

  const [movedField] = targetCategoryState.splice(draggedIndex, 1);
  targetCategoryState.splice(dropIndex, 0, movedField);

  setState(targetCategoryState);

  setDraggedIndex(null);
  setDraggedCategory(null);
};

  return (
    <div>
      <div className="formapp">
        <Side addField={addField} />
        <div className="canvas-save">
          <FormCanvas
            fields={fields}
            addedFields={addedFields}
            updateField={updateField}
            updatedField={updatedField}
            removeField={removeField}
            copiedFields={copiedFields}
            disableRequiredCheckbox={true}
            formSchema={formSchema}
            copyField={copyField}
            removeFieldFromCopied={removeFieldFromCopied}
            updateAddedField={updateAddedField}
            updateCopiedField={updateCopiedField}
            handleDrop={handleDrop}
            handleDragStart={handleDragStart}
            handleDragEnd={handleDragEnd}
            setIsDragging={setIsDragging}
            isDragging={isDragging}
            setDragOverIndex={setDragOverIndex}
            dragOverIndex={dragOverIndex}
            handleDragOver={handleDragOver}
            handleDragLeave={handleDragLeave}

          />
          <div className="registratation_button">
            <GreyBackgroundButton onClick={() => setShowModal(true)}>Preview</GreyBackgroundButton>
            <RedBackgroundButton onClick={saveForm}>Update And Continue</RedBackgroundButton>
            <RedBackgroundButton onClick={saveForm2}>Update And Close</RedBackgroundButton>
          </div>
        </div>
      </div>

      {/* Form Preview Modal */}
      <FormPreview
        formSchema={formSchema}
        showModal={showModal}
        handleClose={() => setShowModal(false)} 
      />
    </div>    
  );
};

  
export default UpdateNewEntryForm
